import { blobUrl } from '../variables';

export const DEFAULT_AVATAR = `${blobUrl}/ui/profile/avatars/defaul.webp`;
